import { render, staticRenderFns } from "./ClickableImageBlock.vue?vue&type=template&id=04a91c93&scoped=true"
import script from "./ClickableImageBlock.vue?vue&type=script&lang=js"
export * from "./ClickableImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ClickableImageBlock.vue?vue&type=style&index=0&id=04a91c93&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a91c93",
  null
  
)

export default component.exports